import { read } from '@/api/rest';

const udc = {
  index: async (params) => await read('/udc?' + params.toString()),
  getDescendants: async (params) => await read('/udc/descendants?' + params.toString()),
};
export default udc;
